import '@sections/collection-carousel.css';
import '@web-components/keen-slider';
import '@web-components/keen-slider-navigation-arrows';
import { Schema } from 'effect';
import { createStore } from 'solid-js/store';
import { createEffect, createResource, on } from 'solid-js';

const BASE_URL = `${window.Shopify.routes.root === '/' ? '' : window.Shopify.routes.root}/collections`;
const VIEW_PARAM = 'view=product-card';

const SectionSettings = Schema.parseJson(
  Schema.Struct({
    collection: Schema.Struct({
      handle: Schema.String,
    }),
  }),
);

const sections = Array.from(document.querySelectorAll<HTMLDivElement>('section.collection-carousel'));

sections.forEach((section) => {
  // const sectionId = getSectionId(section);

  const filtersContainer = section.querySelector<HTMLDivElement>('.filters');
  if (!filtersContainer) return;

  const filters = Array.from(filtersContainer.querySelectorAll<HTMLSelectElement>('.filter'));
  const dataScript = section.querySelector("script[type='application/json']");
  if (!dataScript || !dataScript.textContent || !filters.length) return;

  const settings = Schema.decodeSync(SectionSettings)(dataScript.textContent);
  const collectionUrl = `${BASE_URL}/${settings.collection.handle}`;

  const [selectedFilters, setSelectedFilters] = createStore<Record<string, any>>(
    filters.reduce((final, filter) => {
      return {
        ...final,
        [filter.name]: null,
      };
    }, {}),
  );

  filtersContainer.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLSelectElement)) return;
    setSelectedFilters(target.name, target.value || null);
  });

  const [productCards] = createResource(
    () => {
      const params = Object.entries(selectedFilters).reduce((params, [key, value]) => {
        if (value) return `${params}&${key}=${encodeURIComponent(value)}`;
        return params;
      }, `?${VIEW_PARAM}`);
      return params;
    },
    async (params) => {
      const url = `${collectionUrl}${params}`;
      const domParser = new DOMParser();
      return fetch(url)
        .then((response) => response.text())
        .then((html) =>
          Array.from(domParser.parseFromString(html, 'text/html').querySelectorAll('.product-card')).slice(0, 10),
        );
    },
  );

  let firstLoad = true;

  createEffect(
    on(productCards, (cards) => {
      if (!cards) return;
      if (firstLoad) {
        firstLoad = false;
        return;
      }
      const slider = section.querySelector<HTMLDivElement>('.keen-slider'),
        slideTemplate = slider?.querySelector<HTMLTemplateElement>('template[data-slide]'),
        loadingSlideTemplate = slider?.querySelector<HTMLTemplateElement>('template[data-slide-loading]'),
        slides = Array.from(slider?.querySelectorAll('.keen-slider__slide') || { length: 0 });
      if (!slider || !slideTemplate || !loadingSlideTemplate) return;
      if (productCards.loading) {
        slides.forEach((slide) => slide.remove());
        Array.from({ length: 10 }).forEach(() => {
          const slide = loadingSlideTemplate.content.cloneNode(true);
          slider.appendChild(slide);
        });
        return;
      }
      slides.forEach((slide) => slide.remove());
      cards.forEach((card) => {
        const slide = slideTemplate.content.cloneNode(true) as HTMLElement;
        if (slide.firstElementChild) {
          slide.firstElementChild.innerHTML = card.outerHTML;
        }
        slider.appendChild(slide);
      });
      return;
    }),
  );
});
